module.exports = __webpack_public_path__ + "static/media/5.91a0672c.png";